/*
 * Render-time audience markers. A targeted block is wrapped with
 * `data-gdi-aud="<marker>"` so a pre-paint stylesheet can hide the variants
 * that do not match the shopper before React hydrates (utils/audience-prepaint.js).
 */
import {classifyAudienceTargeting, readEntryTargeting} from './gdi-audience-match'

/** Attribute-selector-safe token: `[A-Za-z0-9_-]` only. */
export const sanitizeToken = (value) => String(value ?? '').replace(/[^A-Za-z0-9_-]/g, '')

/**
 * @param {Object} block expanded GDI block (or a content-area entry)
 * @returns {string | null} `auth:guest` | `auth:loggedin` | `group:<id>` | `ab:<flag>:<variation>`
 */
export const getAudienceMarker = (block) => {
    const target = classifyAudienceTargeting(readEntryTargeting(block))
    if (!target) return null

    switch (target.dim) {
        case 'auth':
            return `auth:${target.variant}`
        case 'group':
            return `group:${sanitizeToken(target.groupId)}`
        case 'ab':
            return `ab:${sanitizeToken(target.flagKey)}:${sanitizeToken(target.variationKey)}`
        default:
            return null
    }
}
